import { TipoTipologica } from '../../common/models/tipologiche/tipo-tipologica';
import { DocumentElaborated } from "./document-elaborated";

export class ElaborationDocumentFilterTopic {
  id?: string;
  tipoTopic?: TipoTipologica;
  valore?: string;
  valoreTag?: string;
  inizio?: number;
  fine?: number;
  elaborazioneDocumento: DocumentElaborated;
}

export class ElaborationDocumentFilterSezione {
  id?: string;
  tipoSezione?: TipoTipologica;
  valore?: string;
  valoreTag?: string;
  inizio?: number;
  fine?: number;
  elaborazioneDocumento: DocumentElaborated;
}

export interface ElaborationDocumentFilterEntity {
  id?: string;
  tipoEntita?: TipoTipologicaEntity;
  elaborazioneDocumento?: DocumentElaborated;
  uri?: string;
  valore?: string;
  valoreTag?: string;
  score?: number;
  occorrenze?: {
    id: string;
    inizio: number;
    fine: number;
    link: {
      id: string;
      idEntita: string;
    }[]
  }[]
}

export interface ElaborationDocumentFilterWrapper {
  tipo: TipoTipologica,
  occorrenze: ElaborationDocumentOccorrenzaMetadata[]
}

export interface ElaborationDocumentFilter {
  tipo: TIPOLOGIA_FILTER,
  wrapper: ElaborationDocumentFilterWrapper,
}

export interface ElaborationDocumentOccorrenzaMetadata {
  inizio: number
  fine: number
}

export interface ElaborationDocumentOccorrenzaMetadataType {
  tipo: TIPOLOGIA_FILTER,
  isApertura: boolean,
  indice: number,
  pageStart:number,
  pageEnd:number
}

export interface TipoTipologicaEntity extends TipoTipologica{
  label_key: string,
  tipo: string
}

export enum TIPOLOGIA_FILTER {
  TOPIC = 'topic',
  ENTITY = 'entity',
  SEZIONE = 'sezione'
}

export function isEntity(filter: ElaborationDocumentFilterEntity | ElaborationDocumentFilterTopic | ElaborationDocumentFilterSezione): filter is ElaborationDocumentFilterEntity {
  return (filter as ElaborationDocumentFilterEntity).tipoEntita !== undefined;
}

export function isTopic(filter: ElaborationDocumentFilterEntity | ElaborationDocumentFilterTopic | ElaborationDocumentFilterSezione): filter is ElaborationDocumentFilterTopic {
  return (filter as ElaborationDocumentFilterTopic).tipoTopic !== undefined;
}

export function isSezione(filter: ElaborationDocumentFilterEntity | ElaborationDocumentFilterTopic | ElaborationDocumentFilterSezione): filter is ElaborationDocumentFilterSezione {
  return (filter as ElaborationDocumentFilterSezione).tipoSezione !== undefined;
}
